import { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import useImagePreloader from '../../hooks/useImagePreloader'

export default function ProductImageCarousel({ productImages = [], aspectRatio = '4/3' }) {
  const [isLoading, setIsLoading] = useState(true)
  const { imagesPreloaded } = useImagePreloader(productImages)

  if (!productImages || productImages.length === 0) {
    return (
      <div
        className="w-full bg-neutral-200 rounded-md flex items-center justify-center"
        style={{ aspectRatio }}
      >
        <p className="text-gray-500">No images available</p>
      </div>
    )
  }

  if (!imagesPreloaded) {
    return (
      <div
        className="w-full bg-neutral-200 rounded-md flex items-center justify-center"
        style={{ aspectRatio }}
      >
        <p className="text-gray-500">Loading images...</p>
      </div>
    )
  }

  return (
    <div className={' product-carousel-container w-full'}>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={10}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        className="w-full rounded-md overflow-hidden "
        style={{
          aspectRatio,
          '--swiper-navigation-size': '20px',
          '--swiper-navigation-color': '#E7790C',
          '--swiper-pagination-bullet-inactive-color': '#E7790C',
          '--swiper-pagination-color': '#E47F00',
        }}
      >
        {productImages.map((image, index) => (
          <SwiperSlide key={index} className="w-full h-full">
            {() => (
              <div className="relative w-full h-full">
                {isLoading && (
                  <div className="absolute inset-0 bg-neutral-200 flex items-center justify-center">
                    <span className="animate-pulse">Loading...</span>
                  </div>
                )}
                <img
                  src={image}
                  alt={`Product image ${index + 1}`}
                  className={`w-full h-full object-contain transition-opacity duration-300 ${
                    isLoading ? 'opacity-0' : 'opacity-100'
                  }`}
                  onLoad={() => setIsLoading(false)}
                  onError={() => setIsLoading(false)}
                />
              </div>
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
